"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _componentsApi = require("@/api/componentsApi");
var _api = require("@/views/business/clientManage/distributor/api");
var _validate = require("@/utils/validate.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      platformStatusEnum: [{
        label: '上架',
        value: 1
      }, {
        label: '下架',
        value: 0
      }],
      supperStatusEnum: [{
        label: '上架',
        value: 1
      }, {
        label: '下架',
        value: 0
      }],
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      tableData: {
        list: [],
        total: 0
      },
      merCateList: [],
      pageFrom: {
        page: 1,
        limit: 15
      },
      searchOptions: [],
      searchLoading: false,
      collapse: false,
      labelLists: [],
      loading: false,
      // 表格loading
      customerId: null,
      ids: [],
      brandList: [],
      suppliers: [],
      JavaInfo: JSON.parse(_jsCookie.default.get('JavaInfo'))
    };
  },
  created: function created() {
    var _this$JavaInfo;
    this.customerId = (_this$JavaInfo = this.JavaInfo) === null || _this$JavaInfo === void 0 ? void 0 : _this$JavaInfo.customerId;
    this.remoteMethod();
    this.getCategorySelect();
    this.getBrandList();
    this.getSupplierList();
    this.getList();
  },
  mounted: function mounted() {
    this.DeleteCouponVueRef = this.$refs.DeleteCouponVueRef;
  },
  methods: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    checkPass: function checkPass() {
      var pass = Boolean(this.customerId);
      if (!pass) {
        this.$message.error('customerId为空');
        return;
      }
      ;
      return pass;
    },
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    // 品牌
    getBrandList: function () {
      var _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
        var _res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _api.getBrandrApi)(params);
            case 1:
              _res = _context.v;
              this.brandList = _res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getBrandList(_x) {
        return _getBrandList.apply(this, arguments);
      }
      return getBrandList;
    }(),
    //远程搜索品牌
    brandRemoteMethod: function brandRemoteMethod(query) {
      if (query !== '') {
        this.getBrandList({
          keyword: query
        });
      }
    },
    //供应商
    getSupplierList: function () {
      var _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
        var _res2, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.customerId) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return (0, _api.getSupplierApi)(params);
            case 2:
              _res2 = _context2.v;
              this.suppliers = _res2 || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getSupplierList(_x2) {
        return _getSupplierList.apply(this, arguments);
      }
      return getSupplierList;
    }(),
    //远程搜素供应商
    supplierRemoteMethod: function supplierRemoteMethod() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (query !== '') {
        this.getSupplierList({
          keyword: query
        });
      }
    },
    //导出
    exportCustomerSku: function exportCustomerSku() {
      if (!this.checkPass()) return; // 邱后端说没有customerId不查询
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.searchForm), {}, {
        customerId: this.customerId
      });
      (0, _api.exportCustomerSkuApi)(params).then(function (res) {
        window.open(res.fileName);
      });
    },
    //导出模板
    exportTemp: function () {
      var _exportTemp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _res3, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _componentsApi.excelTemplateApi)('customerSku.xlsx');
            case 1:
              _res3 = _context3.v;
              window.open(_res3.fileName);
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$message.error(_t3.message);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function exportTemp() {
        return _exportTemp.apply(this, arguments);
      }
      return exportTemp;
    }(),
    //列表选择
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val.map(function (item) {
        return item.id;
      });
    },
    //批量移除
    deleteBatch: function deleteBatch() {
      var _this = this;
      if (this.ids.length == 0) {
        this.$message.error('请选择要删除的数据！');
        return;
      }
      this.$alert('确定要删除吗？', '批量删除', {
        confirmButtonText: '确定',
        callback: function () {
          var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
            var _res4, _t4;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.p = _context4.n) {
                case 0:
                  _context4.p = 0;
                  _context4.n = 1;
                  return (0, _api.deleteBatchApi)(_this.ids);
                case 1:
                  _res4 = _context4.v;
                  _this.$message.success('批量删除成功！');
                  _this.search();
                  _context4.n = 3;
                  break;
                case 2:
                  _context4.p = 2;
                  _t4 = _context4.v;
                  _this.$message.error(_t4.message);
                case 3:
                  return _context4.a(2);
              }
            }, _callee4, null, [[0, 2]]);
          }));
          function callback() {
            return _callback.apply(this, arguments);
          }
          return callback;
        }()
      });
    },
    //商家状态
    onchangeStatus: function () {
      var _onchangeStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _api.updateStatusApi)({
                id: row.id,
                status: row.status
              });
            case 1:
              this.getList();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              this.getList();
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function onchangeStatus(_x3) {
        return _onchangeStatus.apply(this, arguments);
      }
      return onchangeStatus;
    }(),
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 归属公司
    remoteMethod: function remoteMethod(query) {
      var _this3 = this;
      this.searchLoading = true;
      (0, _api.getCompanyListApi)(query).then(function (res) {
        _this3.searchOptions = res.total ? res.list : res;
        _this3.searchLoading = false;
      }).catch(function () {
        _this3.$message.error('请求失败，请稍后再试');
        _this3.searchLoading = false;
      });
    },
    //新增
    addGoods: function addGoods(type) {
      this.$refs.AddGoodsVueRef.open(type);
    },
    // 删除记录
    deleteRecode: function deleteRecode(row) {
      this.$refs.DeleteCouponVueRef.open(row);
    },
    //详情
    detail: function detail(row) {},
    // 列表
    getList: function getList() {
      var _this4 = this;
      if (!this.checkPass()) return; // 邱后端说没有customerId不查询
      this.loading = true;
      (0, _api.customerSkuPageApi)(_objectSpread(_objectSpread({}, this.pageFrom), {}, {
        customerId: this.customerId
      })).then(function (res) {
        _this4.tableData = res;
        _this4.tableData.list = res.list;
        _this4.loading = false;
      }).catch(function (err) {
        _this4.loading = false;
      });
    }
  }, "getCategorySelect", function getCategorySelect() {
    var _this5 = this;
    (0, _store.categoryApi)({
      status: -1,
      type: 1
    }).then(function (res) {
      _this5.merCateList = res;
    }).catch(function (res) {
      _this5.$message.error(res.message);
    });
  }), "changePrice", (0, _validate.Debounce)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
      var _res5, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            _context6.n = 1;
            return (0, _api.updatePriceApi)(row);
          case 1:
            _res5 = _context6.v;
            this.$message.success('价格更新成功！');
            this.getList();
            _context6.n = 3;
            break;
          case 2:
            _context6.p = 2;
            _t6 = _context6.v;
            this.getList();
            this.$message.error(res.message);
          case 3:
            return _context6.a(2);
        }
      }, _callee6, this, [[0, 2]]);
    }));
    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }(), 1000)), "beforeUpload", function beforeUpload(file, type) {
    var formData = new FormData();
    formData.append('file', file);
    switch (type) {
      case 'updatePriceApi':
        this.importData(_api.importUpdatePriceApi, formData, Number(this.customerId));
        break;
      case 'updateStatusApi':
        this.importData(_api.importUpdateStatusApi, formData, Number(this.customerId));
        break;
      case 'updateCustomerSkuApi':
        this.importData(_api.importUpdateCustomerSkuApi, formData, Number(this.customerId));
        break;
      default:
        this.importData(_api.importCustomerSkuApi, formData, Number(this.customerId));
        break;
    }
  }), "importData", function () {
    var _importData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(api, formData, id) {
      var _res6, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            _context7.p = 0;
            _context7.n = 1;
            return api(formData, id);
          case 1:
            _res6 = _context7.v;
            this.$message.success('导入成功！');
            this.search();
            _context7.n = 3;
            break;
          case 2:
            _context7.p = 2;
            _t7 = _context7.v;
            this.$message.error(_t7);
          case 3:
            return _context7.a(2);
        }
      }, _callee7, this, [[0, 2]]);
    }));
    function importData(_x5, _x6, _x7) {
      return _importData.apply(this, arguments);
    }
    return importData;
  }())
};